<template>
  <section>
	<h2>Send Money to your Kids' Cards</h2>
    <v-alert
      v-if="show_alert"
      :type="alert_type"
    >
      {{ alert_text }}
    </v-alert>

    <v-select
        v-model="child_selected"
        :items="children"
        item-text="name"
        item-value="id"
        label="Child to Send To"
    ></v-select>

    <v-text-field
        v-model="amount"
        label="Amount to be sent"
        type="number"
        step="1"
        prefix="$"
    />

    <v-checkbox
      v-model="fund_account_if_insufficient"
      label="Fund my account if the current balance is insufficient for this transfer"
    ></v-checkbox>
    
    <v-btn
        color="success"
        type="submit"
        :loading="pending_submit"
        id='send'
        @click="send"
    >Send</v-btn>
  </section>
</template>

<script>

export default {
	props: ['user','api_prefix'],
	data() {
		return {
          pending_submit: false,
          child_selected: null,
          amount: null,
          show_alert: false,
          alert_type: 'success',
          fund_account_if_insufficient: false,
          alert_text: null,
          children: null
		};
	},
	mounted: function() 
	{
		
	},
	watch: {
    
	},
	computed: {
		
	},
	methods: {
      async get_child_accounts()
      {
        let self = this
        var response = await self.$http.get(self.api_prefix + '/child_account',
          {
          },
        );
        if(response.data!=null)
        {
            self.children = response.data
        }
      },
      async send()
      {
        this.pending_submit = true
        let self = this;

        var response = await self.$http.post(self.api_prefix + '/transfer',
          {
            "child_customer_id": self.child_selected,
            "amount": self.amount,
            "fund_account_if_insufficient": self.fund_account_if_insufficient,
          },
        );
        if(response.data!=null)
        {
          if(response.data.status==true)
          {
            self.alert_text = "Your money has been sent!"
            self.alert_type = 'success'
            self.show_alert = true;

            window.analytics.track("Transfer", {
                'succesful': true,
            });
          }
          else
          {
            self.alert_text = "We were unable to send your money - please chat with support."
            self.alert_type = 'error'
            self.show_alert = true;
            window.analytics.track("Transfer", {
                'succesful': false,
            });
          }
        }
        this.pending_submit = false
        this.$emit('transferred')
      }
	},
	async created() 
	{
    this.get_child_accounts()
    window.analytics.page('Transfer')
	}
};
</script>
